import React from "react";
import { Sparkles } from "lucide-react";

import "./SuggestionCard.css";

const SuggestionCard = ({ title, subtitle, onClick }) => {
  return (
    <button
     className="suggestion-card" 
     onClick={onClick}
     type="button"
     >
       <div className="suggestion-icon">
        <Sparkles size={18} />
      </div>

       <div className="suggestion-content">
        <div className="suggestion-title">{title}</div>
        {subtitle && (
          <div className="suggestion-subtitle">{subtitle}</div>
        )}
      </div>
    </button>
  );
};

export const SuggestionCardSkeleton = () => {
  return (
    <div className="suggestion-card suggestion-skeleton" aria-hidden="true">
      <div className="suggestion-icon suggestion-icon-skeleton" />
      <div className="suggestion-content suggestion-content-skeleton">
        <div className="suggestion-line suggestion-line-title" />
        <div className="suggestion-line suggestion-line-subtitle" />
      </div>
    </div>
  );
};

export default SuggestionCard;
